/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Video.css';
import { default as Video, Controls, Play, Mute, Seek, Fullscreen, Time, Overlay } from 'react-html5video';
import { Link } from 'react-router';
import window from 'window-or-global';
import $ from 'jquery';


@withStyles(s)
export default class VideoBanner extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        };

        this.scrollNext = this.scrollNext.bind(this);
    }

    componentDidMount(){
        
    }

    componentWillUnmount(){
        
    }

    scrollNext() {

        var wHeight = window.innerHeight - 99;
        
        $("html, body").animate({ scrollTop: wHeight }, 1000);

    }

    
    render(){

        return (
            <div className={s.root}>
                <div className={`video`}>
                    <div className={`wrapVideo`}>
                        <video autoPlay loop muted poster="" className={`bgvid`}>
                            <source src='http://www.agenceprolifik.ca/video/bg-video.mp4' type="video/mp4" />
                        </video>
                        <div className={`container`}>
                            <div className={`content`}>
                                <h1 className={`largeScreen`}><i className={`blueText`}>Attirer</i> vos prospects,</h1>
                                <h1 className={`smallScreen`}><i className={`blueText`}>Attirer<br /></i> vos prospects,</h1>
                                <h2 className={`largeScreen`}>Les <i className={`greenText`}>Convertir</i> en clients,</h2>
                                <h2 className={`smallScreen`}><i className={`greenText`}>Convertir<br /></i> votre trafic,</h2>
                                <h3 className={`largeScreen`}><i className={`orangeText`}>Entretenir</i> vos relations.</h3>
                                <h3 className={`smallScreen`}><i className={`orangeText`}>Entretenir<br /></i> vos relations.</h3>
                                <div className={`wrapPar`}>
                                    <p>Prolifik est une agence de stratégie web pour PME qui allie la création de sites web axés sur la conversion et les actions marketing web qui gravitent autour.</p>
                                </div>
                                <h1 className={`largeScreen`}>Notre site est présentement en maintenance !</h1>
                            </div>
                        </div>
                        <div className={`wrapArrow`}>
                            <span className={`arrowDown fadeOutDown`} onClick={() => this.scrollNext()}></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/Video/Video.js